(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9162],{

/***/ 78441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(59499);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50029);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68777);
/* harmony import */ var _components_EasyTrade__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64289);
/* harmony import */ var _components_CTA_v3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69589);
/* harmony import */ var _components_CoreFeatures__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40785);
/* harmony import */ var _components_Tutorials__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69883);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var _api_redux_easytrade__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37973);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(62642);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9975);
/* harmony import */ var gsap_dist_SplitText__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(42757);
/* harmony import */ var gsap_dist_SplitText__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_SplitText__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _api_store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(38584);
/* harmony import */ var _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92495);
/* harmony import */ var _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11267);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85893);






















var EasyTradePage = function EasyTradePage(_ref) {
  var _getPost$posts, _getPost$posts$data, _getPost$posts2, _getPost$posts2$data, _getPost$posts2$data$, _getPost$posts3, _getPost$posts3$data, _getPost$posts3$data$, _getPost$posts4, _getPost$posts4$data, _getPost$posts4$data$, _getPost$posts5, _getPost$posts5$data, _getPost$posts5$data$;

  var offset = _ref.offset,
      smooth = _ref.smooth,
      winWidth = _ref.winWidth;
  var getPost = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function (state) {
    return state.easytradeReducer;
  });
  var page_data = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts = getPost.posts) === null || _getPost$posts === void 0 ? void 0 : (_getPost$posts$data = _getPost$posts.data) === null || _getPost$posts$data === void 0 ? void 0 : _getPost$posts$data.page_data;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();
  var easy = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts2 = getPost.posts) === null || _getPost$posts2 === void 0 ? void 0 : (_getPost$posts2$data = _getPost$posts2.data) === null || _getPost$posts2$data === void 0 ? void 0 : (_getPost$posts2$data$ = _getPost$posts2$data.sections) === null || _getPost$posts2$data$ === void 0 ? void 0 : _getPost$posts2$data$.find(function (f) {
    var _f$section_data;

    return (f === null || f === void 0 ? void 0 : (_f$section_data = f.section_data) === null || _f$section_data === void 0 ? void 0 : _f$section_data.slug) === 'easy-trade-overview';
  });
  var core = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts3 = getPost.posts) === null || _getPost$posts3 === void 0 ? void 0 : (_getPost$posts3$data = _getPost$posts3.data) === null || _getPost$posts3$data === void 0 ? void 0 : (_getPost$posts3$data$ = _getPost$posts3$data.sections) === null || _getPost$posts3$data$ === void 0 ? void 0 : _getPost$posts3$data$.find(function (f) {
    var _f$section_data2;

    return (f === null || f === void 0 ? void 0 : (_f$section_data2 = f.section_data) === null || _f$section_data2 === void 0 ? void 0 : _f$section_data2.slug) === 'core-features';
  });
  var tutorials = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts4 = getPost.posts) === null || _getPost$posts4 === void 0 ? void 0 : (_getPost$posts4$data = _getPost$posts4.data) === null || _getPost$posts4$data === void 0 ? void 0 : (_getPost$posts4$data$ = _getPost$posts4$data.sections) === null || _getPost$posts4$data$ === void 0 ? void 0 : _getPost$posts4$data$.find(function (f) {
    var _f$section_data3;

    return (f === null || f === void 0 ? void 0 : (_f$section_data3 = f.section_data) === null || _f$section_data3 === void 0 ? void 0 : _f$section_data3.slug) === 'tutorials';
  });
  var cta = getPost === null || getPost === void 0 ? void 0 : (_getPost$posts5 = getPost.posts) === null || _getPost$posts5 === void 0 ? void 0 : (_getPost$posts5$data = _getPost$posts5.data) === null || _getPost$posts5$data === void 0 ? void 0 : (_getPost$posts5$data$ = _getPost$posts5$data.sections) === null || _getPost$posts5$data$ === void 0 ? void 0 : _getPost$posts5$data$.find(function (f) {
    var _f$section_data4;

    return (f === null || f === void 0 ? void 0 : (_f$section_data4 = f.section_data) === null || _f$section_data4 === void 0 ? void 0 : _f$section_data4.slug) === 'cta-easy-trade';
  });
  var currentUrl = router && router.asPath;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var split = gsap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].utils.toArray */ .ZP.utils.toArray(".split-up");
    gsap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].registerPlugin */ .ZP.registerPlugin(gsap_dist_SplitText__WEBPACK_IMPORTED_MODULE_15__.SplitText, gsap__WEBPACK_IMPORTED_MODULE_16__/* .CSSPlugin */ ._Z);

    if (window > 767) {
      gsap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].utils.toArray */ .ZP.utils.toArray('.split-up').forEach(function (item, i) {
        var parentSplit = new gsap_dist_SplitText__WEBPACK_IMPORTED_MODULE_15__.SplitText(item, {
          linesClass: "split-parent",
          type: "lines"
        });
        var childSplit = new gsap_dist_SplitText__WEBPACK_IMPORTED_MODULE_15__.SplitText(item, {
          type: "lines",
          linesClass: "split-child"
        });
        gsap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].from */ .ZP.from(parentSplit.lines, {
          duration: 1,
          yPercent: 150,
          ease: 'power4.out',
          stagger: .08,
          scrollTrigger: {
            trigger: item,
            toggleActions: "restart none none reset",
            start: "top 98%"
          }
        });
      });
    }
  }, [getPost]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_11__/* .NextSeo */ .PB, {
      title: "".concat(page_data !== null && page_data !== void 0 && page_data.title ? (page_data === null || page_data === void 0 ? void 0 : page_data.title) + ' | Shanta Securities Limited' : 'Shanta Securities Limited'),
      description: page_data === null || page_data === void 0 ? void 0 : page_data.meta_description,
      canonical: "https://www.shantasecurities.com" + currentUrl,
      openGraph: {
        type: 'website',
        url: "https://www.shantasecurities.com" + currentUrl,
        title: page_data === null || page_data === void 0 ? void 0 : page_data.og_title,
        description: page_data === null || page_data === void 0 ? void 0 : page_data.og_description,
        images: [{
          url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }, {
          url: 'https://res.cloudinary.com/dgxoa4a9i/image/upload/page/landing-page/1688559694xs86e.webp',
          width: 800,
          height: 600,
          alt: page_data === null || page_data === void 0 ? void 0 : page_data.og_title
        }]
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(StyledComponent, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsxs)("div", {
        className: "black",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components_EasyTrade__WEBPACK_IMPORTED_MODULE_2__["default"], {
          video: true,
          data: easy
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          className: "core core_features",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components_CoreFeatures__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            data: core
          })
        }), tutorials && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)("div", {
          className: "tuorital",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components_Tutorials__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            smooth: smooth,
            data: tutorials,
            padding: 'pb-200'
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__.jsx)(_components_CTA_v3__WEBPACK_IMPORTED_MODULE_3__["default"], {
          data: cta,
          offset: offset,
          winWidth: winWidth
        })]
      })
    })]
  });
};

var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_17__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "easytrade__StyledComponent",
  componentId: "sc-uu3e49-0"
})([".finger-tips{padding-top:200px;&:last-child{}@media (max-width:767px){padding-top:120px;}}.finger-tips__text__bottom ul li a img{height:50px !important;}.tuorital{.finger-tips{padding-top:0;padding-bottom:180px !important;@media(max-width:767px){padding-bottom:120px !important;}}}"]);
EasyTradePage.getInitialProps = _api_store__WEBPACK_IMPORTED_MODULE_8__/* .wrapper.getInitialPageProps */ .YS.getInitialPageProps(function (store) {
  return /*#__PURE__*/(0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)( /*#__PURE__*/_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var _param;

    var api_services, param;
    return _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api_services = _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_9__/* .ApiServices.SECTIONS */ .u.SECTIONS;
            param = (_param = {}, (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_10__/* .ApiParamKey.TYPE */ .j.TYPE, 'slug'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_10__/* .ApiParamKey.VALUE */ .j.VALUE, 'shanta-easytrade'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_10__/* .ApiParamKey.GET_SECTION */ .j.GET_SECTION, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_10__/* .ApiParamKey.IMAGE */ .j.IMAGE, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_10__/* .ApiParamKey.POST */ .j.POST, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_10__/* .ApiParamKey.GALLERY */ .j.GALLERY, 'yes'), (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_param, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_10__/* .ApiParamKey.FILE */ .j.FILE, 'yes'), _param);
            _context.next = 4;
            return store.dispatch((0,_api_redux_easytrade__WEBPACK_IMPORTED_MODULE_7__/* .fetchPosts */ .T6)([api_services, param]));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
});
/* harmony default export */ __webpack_exports__["default"] = (EasyTradePage);

/***/ }),

/***/ 63855:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/easytrade",
      function () {
        return __webpack_require__(78441);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7724,7006,1239,1959,1850,4289,2818,9774,2888,179], function() { return __webpack_exec__(63855); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);